/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, ImpersonationSession } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateImpersonationSession(options?: Omit<(UseMutationOptions<(ImpersonationSession | undefined), DefaultError, Prisma.ImpersonationSessionCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionCreateArgs, DefaultError, ImpersonationSession, true>('ImpersonationSession', 'POST', `${endpoint}/impersonationSession/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyImpersonationSession(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ImpersonationSessionCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('ImpersonationSession', 'POST', `${endpoint}/impersonationSession/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationSessionGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findMany`, args, options, fetch);
}

export function useInfiniteFindManyImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationSessionGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findMany`, args, options, fetch);
}

export function useSuspenseFindManyImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationSessionGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindManyArgs, TQueryFnData = Array<Prisma.ImpersonationSessionGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findMany`, args, options, fetch);
}

export function useFindUniqueImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindUniqueArgs, TQueryFnData = Prisma.ImpersonationSessionGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindUniqueArgs, TQueryFnData = Prisma.ImpersonationSessionGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findUnique`, args, options, fetch);
}

export function useFindFirstImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindFirstArgs, TQueryFnData = Prisma.ImpersonationSessionGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstImpersonationSession<TArgs extends Prisma.ImpersonationSessionFindFirstArgs, TQueryFnData = Prisma.ImpersonationSessionGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/findFirst`, args, options, fetch);
}

export function useUpdateImpersonationSession(options?: Omit<(UseMutationOptions<(ImpersonationSession | undefined), DefaultError, Prisma.ImpersonationSessionUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionUpdateArgs, DefaultError, ImpersonationSession, true>('ImpersonationSession', 'PUT', `${endpoint}/impersonationSession/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyImpersonationSession(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ImpersonationSessionUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('ImpersonationSession', 'PUT', `${endpoint}/impersonationSession/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertImpersonationSession(options?: Omit<(UseMutationOptions<(ImpersonationSession | undefined), DefaultError, Prisma.ImpersonationSessionUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionUpsertArgs, DefaultError, ImpersonationSession, true>('ImpersonationSession', 'POST', `${endpoint}/impersonationSession/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteImpersonationSession(options?: Omit<(UseMutationOptions<(ImpersonationSession | undefined), DefaultError, Prisma.ImpersonationSessionDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionDeleteArgs, DefaultError, ImpersonationSession, true>('ImpersonationSession', 'DELETE', `${endpoint}/impersonationSession/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ImpersonationSession, Prisma.ImpersonationSessionGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyImpersonationSession(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ImpersonationSessionDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ImpersonationSessionDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('ImpersonationSession', 'DELETE', `${endpoint}/impersonationSession/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ImpersonationSessionDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ImpersonationSessionDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ImpersonationSessionDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateImpersonationSession<TArgs extends Prisma.ImpersonationSessionAggregateArgs, TQueryFnData = Prisma.GetImpersonationSessionAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateImpersonationSession<TArgs extends Prisma.ImpersonationSessionAggregateArgs, TQueryFnData = Prisma.GetImpersonationSessionAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/aggregate`, args, options, fetch);
}

export function useGroupByImpersonationSession<TArgs extends Prisma.ImpersonationSessionGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ImpersonationSessionGroupByArgs['orderBy'] } : { orderBy?: Prisma.ImpersonationSessionGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ImpersonationSessionGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ImpersonationSessionGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationSessionGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationSessionGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ImpersonationSessionGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByImpersonationSession<TArgs extends Prisma.ImpersonationSessionGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ImpersonationSessionGroupByArgs['orderBy'] } : { orderBy?: Prisma.ImpersonationSessionGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ImpersonationSessionGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ImpersonationSessionGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationSessionGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ImpersonationSessionGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ImpersonationSessionGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/groupBy`, args, options, fetch);
}

export function useCountImpersonationSession<TArgs extends Prisma.ImpersonationSessionCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ImpersonationSessionCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/count`, args, options, fetch);
}

export function useSuspenseCountImpersonationSession<TArgs extends Prisma.ImpersonationSessionCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ImpersonationSessionCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ImpersonationSessionCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ImpersonationSession', `${endpoint}/impersonationSession/count`, args, options, fetch);
}

export function useCheckImpersonationSession<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; impersonator?: string; impersonated?: string; isActive?: boolean }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('ImpersonationSession', `${endpoint}/impersonationSession/check`, args, options, fetch);
}
